import { useQuery } from '@tanstack/react-query';
import { getVideoByID } from '@/services/youtube.service';

export const YOUTUBE_VIDEO_QUERY_KEY = 'youtube-video';

/**
 * useYouTubeVideo — focused TanStack Query hook for the single-video player page.
 *
 * Fetches video details for a single saved YouTube video by its internal UUID.
 * Used by VideoPlayer.tsx to get the external youtube_video_id and metadata
 * needed to initialise the IFrame player (AC: Task 4.1, 4.2).
 *
 * - Only fires when videoId is a non-empty string.
 * - Exposes the nested video object directly via `select` for convenience.
 */
export const useYouTubeVideo = (videoId: string) => {
  return useQuery({
    queryKey: [YOUTUBE_VIDEO_QUERY_KEY, videoId],
    queryFn: () => getVideoByID(videoId),
    select: (data) => data.video,
    enabled: !!videoId,
  });
};
